<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
        
        <div class="vx-row">
        <!-- CARD 1: CONGRATS -->
      
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
                    <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
                    <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
          <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          <h1 class="mb-6 text-white">Bonjour {{ this.$store.state.AppActiveUser.nom }},</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">vous avez  <strong>{{ this.$store.state.notivication.users.length }}</strong> notification. click ici pour aller à la page <router-link to="/apps/email" class="text-inherit">Notification</router-link>.</p>
        </vx-card>
      </div>
            <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="ordersRecevied.analyticsData"
                  icon="ListIcon"
                  :statistic="this.$store.state.statistic.domaines[0].total "
                  statisticTitle="Domaine"
                  :chartData="this.$store.state.statistic.domaines"
                  color='warning'
                  type='area'/>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="ordersRecevied.analyticsData"
                  icon="ListIcon"
                  :statistic="this.$store.state.statistic.formations[0].total "
                  statisticTitle="Formation"
                  :chartData="this.$store.state.statistic.formations"
                  color='warning'
                  type='area' />
            </div>    -->
            
            
            
            
            
        </div>
        <!-- ROW 2 -->
        <div class="vx-row">

            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="ListIcon"
                  icon-right
                  :statistic="this.$store.state.statistic.domaines_f_s.length"
                  statisticTitle="Votre domaine" />
            </div>

            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="ListIcon"
                  icon-right
                  :statistic="formation"
                  statisticTitle="Votre formation"
                   />
            </div>
          
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="ListIcon"
                  icon-right
                  :statistic="this.$store.state.statistic.classes_f_s.length"
                  statisticTitle="Votre classe"
                  color="success" />
            </div>

            
        </div>
        
        
    </div>
</template>

<script>
import moduleclasse from '@/store/classe/moduleclasse.js'
import moduleformation from '@/store/formation/moduleformation.js'
import moduledomaine from '@/store/domaine/moduledomaine.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import modulestatistic from '@/store/Statistic/modulestatistic.js'
export default{
    data() {
        return {
            autreporcent:0,
            autreporcent:0,
            total:null,
            gains:[],
            opts:[],
            subscribersGained: {},
            revenueGenerated: {},
            quarterlySales: {},
            ordersRecevied: {},

            revenueComparisonLine: {},
            goalOverview: {},

            browserStatistics: [],
            clientRetentionBar: {},

            sessionsData: {},
            chatLog: [],
            chatMsgInput: '',
            customersData: {},

            analyticsData: analyticsData,
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
        }
    },
    components: {
        VueApexCharts,
        StatisticsCardLine,
        VuePerfectScrollbar,
        ChangeTimeDurationDropdown
    },
    mounted() {
    },
    computed: {
        formation(){
          return this.$store.state.statistic.formations_f_s.length;
        }
       
    },
    methods: {

    getPopularityColor(num) {
      if(num > 40) return "success"
      if(num >20) return "primary"
      if(num >= 10) return "warning"
      if(num < 5) return "danger"
      return "primary"
    },},
    created() {
    // if(!moduleclasse.isRegistered) {
    //   this.$store.registerModule('classe', moduleclasse)
    //   moduleclasse.isRegistered = true
    // }
    // this.$store.dispatch("classe/fetchClassesCandidat",this.$store.state.AppActiveUser.id)
    //     //statistic
    //     if(!moduleformation.isRegistered) {
    //   this.$store.registerModule('formation', moduleformation)
    //   moduleformation.isRegistered = true
    // }
    // this.$store.dispatch("formation/fetchFormationsCandidat",this.$store.state.AppActiveUser.id)
    //     if(!moduledomaine.isRegistered) {
    //   this.$store.registerModule('domaine', moduledomaine)
    //   moduledomaine.isRegistered = true
    // }
        
    //     this.$store.dispatch("domaine/fetchDomainesCandidat",this.$store.state.AppActiveUser.id).catch(err => { console.error(err) })
        
        if(!modulestatistic.isRegistered) {
        this.$store.registerModule('statistic', modulestatistic)
        modulestatistic.isRegistered = true
        }
       
       this.$store.dispatch("statistic/fetchCandidat").catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchFormateur").catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchFormation").catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchDomaine").catch(err => { console.error(err) })
       
       this.$store.dispatch("statistic/fetchClassesFormateur",this.$store.state.AppActiveUser.id).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchFormationsFormateur",this.$store.state.AppActiveUser.id).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchDomainesFormateur",this.$store.state.AppActiveUser.id).catch(err => { console.error(err) })
       //console.log('1',this.$store.state.statistic.candidats)
       //console.log('12',this.$store.state.statistic.formateurs)
      // Subscribers gained - Statistics
      this.$http.get("/api/card/card-statistics/subscribers")
        .then((response) => { this.subscribersGained = response.data })
        .catch((error) => { console.log(error) })

      // Revenue Generated
      this.$http.get("/api/card/card-statistics/revenue")
        .then((response) => { this.revenueGenerated = response.data })
        .catch((error) => { console.log(error) })

      // Sales
      this.$http.get("/api/card/card-statistics/sales")
        .then((response) => { this.quarterlySales = response.data })
        .catch((error) => { console.log(error) })

      // Orders - Statistics
      this.$http.get("/api/card/card-statistics/orders")
        .then((response) => { this.ordersRecevied = response.data })
        .catch((error) => { console.log(error) })

      // Revenue Comparison
      this.$http.get("/api/card/card-analytics/revenue-comparison")
        .then((response) => { this.revenueComparisonLine = response.data })
        .catch((error) => { console.log(error) })
     
      // Goal Overview
      this.$http.get("/api/card/card-analytics/goal-overview")
        .then((response) => { this.goalOverview = response.data })
        .catch((error) => { console.log(error) })

      // Browser Analytics
      this.$http.get("/api/card/card-analytics/browser-analytics")
        .then((response) => { this.browserStatistics = response.data })
        .catch((error) => { console.log(error) })

      // Client Retention
      this.$http.get("/api/card/card-analytics/client-retention")
        .then((response) => { this.clientRetentionBar = response.data })
        .catch((error) => { console.log(error) })

      // Sessions By Device
      this.$http.get("/api/card/card-analytics/session-by-device")
        .then((response) => { this.sessionsData = response.data })
        .catch((error) => { console.log(error) })

      // Chat Log
      this.$http.get("/api/chat/demo-1/log")
        .then((response) => { this.chatLog = response.data })
        .catch((error) => { console.log(error) })

      // Customers
      this.$http.get("/api/card/card-analytics/customers")
        .then((response) => { this.customersData = response.data })
        .catch((error) => { console.log(error) })
        setTimeout(() => {
        this.$vs.loading.close()
        }, 2000);
        
             
    }
}
</script>

<style lang="scss">
.chat-card-log {
    height: 400px;

    .chat-sent-msg {
        background-color: #f2f4f7 !important;
    }
}
.greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
</style>
